module.exports = __webpack_public_path__ + "static/media/video-blue.96fee613.svg";